<div class="flex flex-col flex-auto min-w-0">
    <div class="border-t -mt-px py-2">
        <div class="w-full max-w-screen-xl mx-auto">
            <div class="py-2">
                <div class="grid grid-cols-1 sm:grid-cols-4 gap-6 w-full min-w-0 p-5">
                    <div class="col-span-2 sm:col-span-1 lg:col-span-1 bg-card shadow rounded-2xl overflow-hidden">
                        <div class="card-header px-6 py-3">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate">
                                CM Status
                            </div>
                        </div>

                        <div class="px-6 py-14">
                            <div id="cmCompletenesspieChart" class="h-64"></div>
                        </div>
                    </div>

                    <div class="col-span-2 sm:col-span-3 lg:col-span-3 bg-card shadow rounded-2xl overflow-hidden">
                        <div class="row justify-between card-header px-6 py-3">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate">
                                CM backlog by Equipment
                            </div>
                        </div>

                        <div class="px-6 pt-4 pb-2">
                            <div id="failEquipCatBarGraph" class="h-64">
                            </div>
                            <!-- Custom 2-row horizontal scrollable legend -->
                            <div id="failEquipLegend" style="overflow-x: auto; overflow-y: hidden; padding: 8px 0;">
                            </div>
                        </div>
                    </div>

                    <div class="sm:col-span-4 lg:col-span-4 bg-card shadow rounded-2xl overflow-hidden">
                        <div class="row justify-between card-header px-6 py-3">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate">
                                Remedial Progress
                            </div>
                        </div>

                        <div class="px-6 pt-4 pb-2">
                            <div id="remedialProgressGraph" class="h-96">
                            </div>
                        </div>
                    </div>


                    <div class="sm:col-span-4 lg:col-span-4  bg-card shadow rounded-2xl overflow-hidden p-6">
                        <div role="tablist" class="tabs tabs-boxed w-2/4 mt-2 mb-12">
                            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': router.url.includes('field')}"
                                (click)="toggleSummary('field')">
                                Field Summary
                            </a>
                            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': !router.url.includes('field')}"
                                (click)="toggleSummary('string')">
                                String Summary
                            </a>
                        </div>

                        <router-outlet></router-outlet>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>